import { render, staticRenderFns } from "./cu-buttons.vue?vue&type=template&id=9888f12a"
import script from "./cu-buttons.vue?vue&type=script&lang=js"
export * from "./cu-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports